import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_AUTH_USER_SUCCESS,
  GET_AUTH_USER_FAIL,
  UPDATE_AUTH_USER_FAIL,
  UPDATE_AUTH_USER_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  auth: {},
  sales: {},
  designers: {},
  lastAction: null, // ✅ add this

}

const login = (state = initialState, action) => {
  switch (action.type) {

    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      return state

    case LOGOUT_USER:
      return { ...state, auth: {}, sales: {}, designers: {} }

    case LOGOUT_USER_SUCCESS:
      return { ...state, auth: {}, sales: {}, designers: {} }


    case API_ERROR:
      return {
        ...state,
        error: action.payload, loading: false
      }

    case GET_AUTH_USER_SUCCESS: {
      let key;
      console.log("GET_AUTH_USER_SUCCESS", action.payload.url);
      switch (action.payload.url) {
        case "/designers":
          key = "designers";
          break;
        case "/assToSalesMan":
          key = "sales";
          break;
        default:
          key = "auth";
      }
      console.log("key", key);
      return {
        ...state,
        [key]: action.payload.auth,
      };
    }

    case GET_AUTH_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
      


    case UPDATE_AUTH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        auth: action.payload.auth,
        lastAction: UPDATE_AUTH_USER_SUCCESS, // ✅ track action
      };
      
    case UPDATE_AUTH_USER_FAIL:
      return {
        ...state,
        loading: false,
        error:action.payload,
        lastAction: UPDATE_AUTH_USER_FAIL,
      };

    default:
      return { ...state, lastAction: action.type }; // ✅ track all actions
  }
  // return state
}

export default login
